import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api/api.service';
import {Subject} from "rxjs";
import {Component as WireComponent} from "../../_models/component";
import {first, takeUntil} from 'rxjs/operators';
import {COMPONENT_EVENTS_CONFIG} from "../../_typing/config/component-events-table";
import {HeaderDataService} from "../../services/header_data.service";
import {NotificationService} from "../../services/notification.service";
import {SelectSearchComponent} from "../../components/select-search/select-search.component";
import {ComponentEventsTableComponent} from "../component-events-table/component-events-table.component";
import {COMMON_FORM_IMPORTS} from "../../shared/import-groups/Common";



@Component({
    selector: 'src-single-component-events-table-view',
    templateUrl: './single-component-events-table-view.component.html',
    imports: [
    SelectSearchComponent,
    ComponentEventsTableComponent,
    COMMON_FORM_IMPORTS
],
    styleUrls: ['./single-component-events-table-view.component.less']
})
export class SingleComponentEventsTableViewComponent implements OnInit {
    private readonly onDestroy = new Subject<void>();
    components: WireComponent[];
    selected_component: WireComponent;
    selected_component_name: string;
    config: COMPONENT_EVENTS_CONFIG;

    constructor(private api: ApiService,
                private headerData: HeaderDataService,
                private notification: NotificationService) {
        this.api.component.searchMany().pipe(first(), takeUntil(this.onDestroy))
            .subscribe(results => {
                this.components = results.data;
                this.components = this.components.filter(item => item.attributes.name)
            })
        this.buildHeader();
    }

    ngOnInit(): void {
    }

    componentScanned(event) {
        let found = this.components.find(item => item.attributes.name.toLowerCase() === this.selected_component_name.toLowerCase());
        if (found) {
            this.selected_component = found;
            this.componentSelected();
        } else {
            this.notification.openError(event + ' not found. Please check the name and try again.');
        }
    }

    componentSelected() {
        this.selected_component_name = this.selected_component?.attributes?.name;
        this.config = {component: null};
        const base = this.selected_component.attributes?.base_type || this.selected_component.type;
        this.api[base].getById(this.selected_component.id).pipe(first(), takeUntil(this.onDestroy))
            .subscribe(result => {
                this.config.component = result.data;
            })
    }

    buildHeader() {
        const ctrl = this;
        ctrl.headerData.title = 'Component Events Table';
        ctrl.headerData.show_dtp = true;

    };

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.unsubscribe();
    }
}
